export const regexFrenchPhone = new RegExp(
  /^(?:0|\+33 ?|0?0?33 ?|)([1-9] ?(?:[0-9] ?){8})$/,
);
